import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { CheckCircle, Clock, LogOut, Home } from 'lucide-react'
import { Button } from '../../components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card'
import { useAuth } from '../../context/AuthContext'

const CBTSubmissionSuccess = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { logout } = useAuth()
  const [countdown, setCountdown] = useState(8)

  useEffect(() => {
    // Start countdown for auto-logout
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          handleLogout()
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [location.state])

  const handleLogout = async () => {
    try {
      await logout()
      // Clear any CBT-related data
      localStorage.removeItem('cbt_submission_data')
      localStorage.removeItem('cbt_exam_backup')
      localStorage.removeItem('cbt_exam_final_submission')
      navigate('/cbt')
    } catch (error) {
      console.error('Logout failed:', error)
      navigate('/cbt')
    }
  }

  const handleReturnToLogin = () => {
    handleLogout()
  }

  const handleGoHome = () => {
    navigate('/dashboard')
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-2xl">
        <CardHeader className="text-center">
          <div className="flex items-center justify-center mb-4">
            <div className="w-20 h-20 bg-green-600 rounded-full flex items-center justify-center">
              <CheckCircle className="w-10 h-10 text-white" />
            </div>
          </div>
          <CardTitle className="text-3xl font-bold text-gray-900">Exam Submitted Successfully!</CardTitle>
        </CardHeader>
        
        <CardContent className="space-y-6">
          {/* Auto-logout Warning */}
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <div className="flex items-center justify-center space-x-2">
              <Clock className="w-5 h-5 text-yellow-600" />
              <span className="text-yellow-800 font-medium">
                You will be automatically logged out in {countdown} seconds
              </span>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-center space-x-4">
            <Button
              variant="outline"
              onClick={handleGoHome}
              className="flex items-center space-x-2"
            >
              <Home className="w-4 h-4" />
              <span>Go to Dashboard</span>
            </Button>
            
            <Button
              onClick={handleReturnToLogin}
              className="bg-blue-600 hover:bg-blue-700 text-white flex items-center space-x-2"
            >
              <LogOut className="w-4 h-4" />
              <span>Logout Now</span>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default CBTSubmissionSuccess
